const RankingSkeleton = () => {
  return (
    <div className="h-full mt-2 rounded flex-col w-full flex gap-5 overflow-hidden bg-secondary-background">
      <div className="bg-secondary-skeleton w-full rounded h-[20px]"></div>
      <div className="bg-secondary-skeleton w-full rounded h-[20px]"></div>
      <div className="bg-secondary-skeleton w-full rounded h-[20px]"></div>
      <div className="bg-secondary-skeleton w-full rounded h-[20px]"></div>
      <div className="bg-secondary-skeleton w-full rounded h-[20px]"></div>
      <div className="bg-secondary-skeleton w-full rounded h-[20px]"></div>
      <div className="bg-secondary-skeleton w-full rounded h-[20px]"></div>
      <div className="bg-secondary-skeleton w-full rounded h-[20px]"></div>
      <div className="bg-secondary-skeleton w-full rounded h-[20px]"></div>
      <div className="bg-secondary-skeleton w-full rounded h-[20px]"></div>
      <div className="bg-secondary-skeleton w-full rounded h-[20px]"></div>
      <div className="bg-secondary-skeleton w-full rounded h-[20px]"></div>
      <div className="bg-secondary-skeleton w-full rounded h-[20px]"></div>
      <div className="bg-secondary-skeleton w-full rounded h-[20px]"></div>
      <div className="bg-secondary-skeleton w-full rounded h-[20px]"></div>
      <div className="bg-secondary-skeleton w-full rounded h-[20px]"></div>
    </div>
  )
}

export default RankingSkeleton
